import { TableColumnsItem } from "../../interfaces/components/mainTable";
import { BillingCode, BillingCodeType } from "../../interfaces/screens/billing";
import { ColumnType, ButtonType } from "../utils/enums";
import CurrencyDisplay from "../../components/currencyDisplay";
import { Edit, Trash2 } from "lucide-react";
import TypeBadge from "../../components/typeBadge";

interface BillingCodesTableColumnsProps {
  onEdit: (code: BillingCode) => void;
  onDelete: (code: BillingCode) => void;
}

const getBadgeClass = (type: BillingCodeType) => {
  switch (type) {
    case "cpt":
      return "bg-blue-100 text-blue-800";
    case "icd":
      return "bg-green-100 text-green-800";
    case "ndc":
      return "bg-purple-100 text-purple-800";
    case "service":
      return "bg-yellow-100 text-yellow-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};

export const getBillingCodesTableColumns = ({
  onEdit,
  onDelete,
}: BillingCodesTableColumnsProps): TableColumnsItem[] => {
  return [
    {
      key: "code",
      name: "Code",
      type: ColumnType.TEXT,
    },
    {
      key: "description",
      name: "Description",
      type: ColumnType.TEXT,
      customCellClass: "w-1/2",
    },
    {
      key: "type",
      name: "Type",
      type: ColumnType.CUSTOM,
      customValue: (row: BillingCode) => <TypeBadge type={row.type} />,
    },
    {
      key: "unit_price",
      name: "Unit Price",
      type: ColumnType.CUSTOM,
      customValue: (row: BillingCode) => {
        if (row.unit_price === null || row.unit_price === undefined) {
          return <span className="text-gray-400">N/A</span>;
        }
        return <CurrencyDisplay amount={row.unit_price} currency="USD" />;
      },
    },
    {
      key: "actions",
      name: "Actions",
      type: ColumnType.BUTTON,
      width: "100px",
      cardOrder: 999,
      buttonsList: [
        {
          type: ButtonType.ICON,
          onPress: (e: React.MouseEvent, row: BillingCode) => {
            e.stopPropagation();
            onEdit(row);
          },
          cssClass:
            "p-2 rounded-full text-gray-500 hover:bg-gray-100 hover:text-blue-600",
          icon: Edit,
        },
        {
          type: ButtonType.ICON,
          onPress: (e: React.MouseEvent, row: BillingCode) => {
            e.stopPropagation();
            onDelete(row);
          },
          cssClass:
            "p-2 rounded-full text-red-600 hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-500/10",
          icon: Trash2,
        },
      ],
    },
  ];
};
